import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=cd2e99fc&scoped=true"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=cd2e99fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2e99fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd2e99fc')) {
      api.createRecord('cd2e99fc', component.options)
    } else {
      api.reload('cd2e99fc', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=cd2e99fc&scoped=true", function () {
      api.rerender('cd2e99fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/customer/onboarding/DataForm.vue"
export default component.exports